import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
    mutation LoginMutation($login: String!, $password: String!) {
        loginWithCookies(input: { password: $password, login: $login }) {
            status
        }
    }
`;
